import { render, staticRenderFns } from "./CardBlamable.vue?vue&type=template&id=65a1e295&scoped=true&"
import script from "./CardBlamable.vue?vue&type=script&lang=ts&"
export * from "./CardBlamable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a1e295",
  null
  
)

export default component.exports